const FilterGenres = [
  {
    id: 28,
    name: 'Action',
  },
  {
    id: 35,
    name: 'Comedy',
  },
  {
    id: 18,
    name: 'Drama',
  },
  {
    id: 27,
    name: 'Horror',
  },
  {
    id: 10402,
    name: 'Music',
  },
  {
    id: 878,
    name: 'Science Fiction',
  },
]

export default FilterGenres
